module.exports = __webpack_public_path__ + "img/system-county-am.626d5c53.png";